<template>
  <ankh-list :showBtnGroup="false">

    <template #search-form>
      <el-form-item :label="$t('编号')">
        <el-input :placeholder="$t('编号')" v-model="searchForm.num" clearable />
      </el-form-item>

      <el-form-item :label="$t('话题')">
        <el-input :placeholder="$t('话题')" v-model="searchForm.topicName" clearable />
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <date-time-range-picker
            :end-time.sync="searchForm.endCreateTime"
            :start-time.sync="searchForm.startCreateTime" />
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          row-key="id"
          :search-params="searchForm"
          :request-params="{userNum: $route.query.num}"
          :data="tableData"
          @query="handleSearch"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column align="center" prop="num" :label="$t('编号')" />
        <el-table-column align="center" prop="content" :label="$t('内容')" />
        <el-table-column align="center" prop="name" :label="$t('图片')">
          <template v-slot="{row}">
            <preview-img :size="40" :img-url="row.photo" :length="3" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="topic" :label="$t('话题')" />
        <el-table-column align="center" prop="commentCount" :label="$t('评论数')" />
        <el-table-column align="center" prop="likeCount" :label="$t('点赞数')" />
        <el-table-column align="center" :label="$t('发布时间')">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" align="center">
          <template v-slot="{row}">
            <el-link type="primary" :underline="false" >{{ $t('查看') }}</el-link>
          </template>
        </el-table-column>

      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker.vue";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserDynamicList",
  components: {AnkhList, DateTimeRangePicker, PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.dynamics.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      }catch(e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
